module.exports = __webpack_public_path__ + "assets/img/分组 15.b342b2a2.png";